import { render, staticRenderFns } from "./category-menu-add.vue?vue&type=template&id=4d7b2c36&scoped=true"
import script from "./category-menu-add.vue?vue&type=script&lang=js"
export * from "./category-menu-add.vue?vue&type=script&lang=js"
import style0 from "./category-menu-add.vue?vue&type=style&index=0&id=4d7b2c36&prod&lang=scss&scoped=true"
import style1 from "./category-menu-add.vue?vue&type=style&index=1&id=4d7b2c36&prod&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4d7b2c36",
  null
  
)

export default component.exports